import { Dispatch, SetStateAction } from 'react'
import { ISwitch } from '../../../models/ISwitch'

interface Props {
    containerWidth: number,
    containerHeight: number,
    activeTextColor: string,
    inActiveTextColor: string,
    borderColor: string,
    buttonBackgroundColor: string,
    switchBackgroundColor: string,
    switches: ISwitch[],
    selectedSwitch: ISwitch,
    setSelectedSwitch: Dispatch<SetStateAction<ISwitch>>
}

const Switches = ({
        containerWidth,
        containerHeight,
        activeTextColor,
        inActiveTextColor,
        borderColor,
        buttonBackgroundColor,
        switchBackgroundColor,
        switches,
        selectedSwitch,
        setSelectedSwitch
    }: Props
) => {

    const count = switches.length

    const width = (containerWidth - 3) / count

    const translateX = (width * (selectedSwitch.id - 1))

    return (
        <div
            style={{
                width: `${containerWidth}px`,
                height: `${containerHeight}px`,
                float: 'left',
                position: 'relative',
                border: '1px solid',
                borderRadius: '10px',
                boxSizing: 'border-box',
                borderColor: borderColor
            }}
        >
            <div
                style={{
                    width: `${width - 1}px`,
                    height: `${containerHeight - 4}px`,
                    position: 'absolute',
                    top: '1px',
                    left: '1px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    fontFamily: 'UbuntuBold',
                    fontSize: '1.2em',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                    color: activeTextColor,
                    backgroundColor: switchBackgroundColor,
                    transform: `translateX(${translateX}px)`,
                    transition: 'all 0.2s'
                    
                }}
            >
                {switches[selectedSwitch.id - 1].title}
            </div>
            {
                switches.map(
                    (item) => (
                        <button
                            key={item.id}
                            onClick={() => setSelectedSwitch(item)}
                            style={{
                                width: width - 1,
                                height: `${containerHeight - 4}px`,
                                margin: '1px 0px 1px 1px',
                                borderRadius: '8px',
                                border: 'none',
                                fontFamily: 'UbuntuBold',
                                fontSize: '1em',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                                color: item.id === selectedSwitch.id ? activeTextColor : inActiveTextColor,
                                backgroundColor: buttonBackgroundColor,
                                transition: 'all 0.2s'
                            }}
                        >
                            {item.title}
                        </button>
                    )
                )
            }
        </div>
    )
}

export default Switches